// import {
//   DETAIL_ROW_HEIGHT,
//   DOM_LAYOUT,
//   EXTRA_HEADER_COMPONENT,
//   PAGINATION_PAGE_SIZE
// } from 'pages/Administration/constants'

// imports removed due to probable circular dependency causing bug
const DOM_LAYOUT = 'autoHeight'
const EXTRA_HEADER_COMPONENT = 'extraComponent'
const PAGINATION_PAGE_SIZE = 10
const DETAIL_ROW_HEIGHT = 480

export const PERMISSION_COLUMNS = (t) => ({
  read: (disabled, isOutput = false) => ({
    headerName: t('RolesManagement.RolesColumn.Read'),
    headerTooltip: t('RolesManagement.RolesColumn.Read'),
    field: 'permission',
    colId: 'read',
    // type: 'checkbox',
    maxWidth: 110,
    flex: 2,
    hide: false,
    cellRenderer: 'permissionRenderer',
    valueFormatter: ({ value }) => value?.read,
    cellRendererParams: {
      permissionType: {
        id: 'read',
        disabled
      },
      isOutput
    }
  }),
  create: (disabled, isOutput = false) => ({
    headerName: t('RolesManagement.RolesColumn.Create'),
    headerTooltip: t('RolesManagement.RolesColumn.Create'),
    field: 'permission',
    colId: 'create',
    // type: 'checkbox',
    maxWidth: 110,
    flex: 2,
    hide: false,
    cellRenderer: 'permissionRenderer',
    valueFormatter: ({ value }) => value?.create,
    cellRendererParams: {
      permissionType: {
        id: 'create',
        disabled
      },
      isOutput
    }
  }),
  update: (disabled, isOutput = false) => ({
    headerName: t('RolesManagement.RolesColumn.Update'),
    headerTooltip: t('RolesManagement.RolesColumn.Update'),
    field: 'permission',
    colId: 'update',
    // type: 'checkbox',
    maxWidth: 120,
    flex: 2,
    hide: false,
    cellRenderer: 'permissionRenderer',
    valueFormatter: ({ value }) => value?.update,
    cellRendererParams: {
      permissionType: {
        id: 'update',
        disabled
      },
      isOutput
    }
  }),
  deletion: (disabled, isOutput = false) => ({
    headerName: t('RolesManagement.RolesColumn.Delete'),
    headerTooltip: t('RolesManagement.RolesColumn.Delete'),
    field: 'permission',
    colId: 'delete',
    // type: 'checkbox',
    maxWidth: 110,
    flex: 2,
    hide: false,
    cellRenderer: 'permissionRenderer',
    valueFormatter: ({ value }) => value?.delete,
    cellRendererParams: {
      permissionType: {
        id: 'delete',
        disabled
      },
      isOutput
    }
  }),
  import_: (disabled, isOutput = false) => ({
    headerName: t('RolesManagement.RolesColumn.Import'),
    headerTooltip: t('RolesManagement.RolesColumn.Import'),
    field: 'permission',
    colId: 'import_',
    // type: 'checkbox',
    maxWidth: 110,
    flex: 2,
    hide: false,
    cellRenderer: 'permissionRenderer',
    valueFormatter: ({ value }) => value?.import,
    cellRendererParams: {
      permissionType: {
        id: 'import_',
        disabled
      },
      isOutput
    }
  }),
  export: (disabled, isOutput = false) => ({
    headerName: t('RolesManagement.RolesColumn.Export'),
    headerTooltip: t('RolesManagement.RolesColumn.Export'),
    field: 'permission',
    colId: 'export',
    // type: 'checkbox',
    maxWidth: 110,
    flex: 2,
    hide: false,
    cellRenderer: 'permissionRenderer',
    valueFormatter: ({ value }) => value?.export,
    cellRendererParams: {
      permissionType: {
        id: 'export',
        disabled
      },
      isOutput
    }
  })
})

const defaultColDef = {
  flex: 1,
  sortable: true,
  animateRows: true,
  floatingFilter: true,
  minWidth: 220,
  resizable: true
}

const defaultTableConfigs = {
  suppressDragLeaveHidesColumns: true,
  suppressMovable: true,
  lockPosition: true,
  rowMultiSelectWithClick: false,
  enableCellChangeFlash: true,
  singleClickEdit: true,
  suppressRowClickSelection: true,
  suppressAggFuncInHeader: true,
  pagination: true,
  detailRowAutoHeight: true,
  colResizeDefault: 'shift',
  keepDetailRowsCount: true,
  detailRowHeight: DETAIL_ROW_HEIGHT,
  domLayout: DOM_LAYOUT,
  paginationPageSize: PAGINATION_PAGE_SIZE || 10,
  extraHeaderComponentContainerClassName: EXTRA_HEADER_COMPONENT,
  defaultColDef: defaultColDef
}

const defaultFieldTableConfigs = {
  suppressDragLeaveHidesColumns: true,
  suppressMovable: true,
  lockPosition: true,
  rowMultiSelectWithClick: true,
  enableCellChangeFlash: true,
  singleClickEdit: true,
  suppressRowClickSelection: true,
  rowSelection: 'multiple',
  suppressAggFuncInHeader: true,
  pagination: true,
  detailRowAutoHeight: true,
  colResizeDefault: 'shift',
  keepDetailRowsCount: true,
  detailRowHeight: DETAIL_ROW_HEIGHT,
  domLayout: DOM_LAYOUT,
  paginationPageSize: PAGINATION_PAGE_SIZE || 10,
  extraHeaderComponentContainerClassName: EXTRA_HEADER_COMPONENT,
  defaultColDef: defaultColDef,
  keepDetailRows: true
}

const defaultDetailTableConfigs = {
  // suppressDragLeaveHidesColumns: true,
  // suppressMovable: true,
  // lockPosition: true,
  rowSelection: 'multiple',
  rowMultiSelectWithClick: false,
  // enableCellChangeFlash: true,
  // singleClickEdit: true,
  suppressRowClickSelection: true,
  // suppressAggFuncInHeader: true,
  // pagination: true,
  // detailRowAutoHeight: true,
  // colResizeDefault: 'shift',
  keepDetailRowsCount: true,
  detailRowHeight: DETAIL_ROW_HEIGHT,
  domLayout: DOM_LAYOUT,
  paginationPageSize: PAGINATION_PAGE_SIZE || 10,
  // extraHeaderComponentContainerClassName: EXTRA_HEADER_COMPONENT,
  defaultColDef: defaultColDef
}

const defaultTableConfigsWithMultiple = Object.assign({}, defaultTableConfigs)
defaultTableConfigsWithMultiple.rowSelection = 'multiple'

export {
  defaultTableConfigs,
  defaultDetailTableConfigs,
  defaultTableConfigsWithMultiple,
  defaultFieldTableConfigs
}
